import accedoOVP from './accedo/accedoOvp';

const ovp = accedoOVP;

export default ovp;
